<template>
  <div class="fotter">
    <div class="address">露晰得中国 | 上海有康医疗器械有限公司</div>
    
    <div class="address">
      Copyright © 2009-现在 UCARE Inc.保留所有权利。
      <a href="https://beian.miit.gov.cn/" style="color: inherit"
        >沪ICP备10213750号
      </a>
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502009252"
        style="
          display: inline-block;
          text-decoration: none;
          height: 20px; /* line-height:20px; */
          color: inherit;
        "
        ><img
          src="data:image/png;base64,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"
          style="float: left; margin: 0 5px; width: 14px"
        /><span style="color: #747474">沪公网安备 31011502009252号</span></a
      >
    </div>
    <div class="address">
      [U'CARE] is a subsidiary of the global eye health company, Euclid Vision Group™.
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.fotter {
  margin-top: 30px;
}
.address {
  color: #747474;
  font-size: 12px;
  height: 15px;
  margin-bottom: 10px;
}
</style>